import styled from 'styled-components'

const StyledCaptionLibraryHeader = styled.div`
  .page-header-top {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-gap: 10px;

    .page-header-search-input {
      width: 100%;
      grid-column: 1/3;

      .input-icon {
        left: 11px;
        height: 23px;
        width: 23px;

        svg {
          path {
            stroke-width: 1.75px;
          }
        }
      }

      .input-container-border-group {
        .input-container-border {
          &.left {
            border-top-left-radius: 6px;
            border-bottom-left-radius: 6px;
          }

          &.right {
            border-top-right-radius: 6px;
            border-bottom-right-radius: 6px;
          }
        }
      }

      input {
        height: 48px;
        font-size: 1rem;
        padding: 0 20px 0 45px;
      }
    }

    .page-header-action {
      height: 48px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      width: 100%;
      transition: 0.2s;
      grid-column: 1/3;
      background-color: ${({ theme }) => theme.colors.background};
      border: 1px solid ${({ theme }) => theme.colors.gray[300]};

      * {
        font-size: 1rem;
        font-family: ${({ theme }) => theme.fonts.nunito};
      }

      &.dropdown {
        select {
          height: 48px;
          border: 0;
          width: 100%;
          outline: none;
          background-color: transparent;
          color: ${({ theme }) => theme.colors.gray[600]};
          padding: 0 60px 0 14px;
          -webkit-appearance: none;
          -moz-appearance: none;
          text-indent: 1px;
          text-overflow: '';

          &:hover {
            cursor: pointer;
          }
        }

        svg {
          top: 50%;
          pointer-events: none;
          right: 12px;
          position: absolute;
          transform: translateY(-50%);
          height: 20px;
          color: ${({ theme }) => theme.colors.gray[300]};
        }
      }

      &:hover {
        cursor: pointer;
        background-color: ${({ theme }) => theme.colors.gray[100]};
      }
    }
  }

  .page-header-categories {
    margin-top: 10px;
    display: grid;
    grid-gap: 8px;
    grid-template-columns: auto auto minmax(0, 1fr);

    .bubble {
      margin: 0;
    }
  }

  @media (min-width: ${({ theme }) => `${theme.breakpoints.m}px`}) {
    .page-header-top {
      grid-template-columns: minmax(0, 1fr) auto;

      .page-header-search-input {
        grid-column: unset;
      }

      .page-header-action {
        grid-column: unset;
      }
    }
  }
`

export default StyledCaptionLibraryHeader
